import * as React from "react";
import { Navigate, useLocation } from "react-router";

const ProtectedRoute = (props: any) => {
  const location = useLocation();
  let isAuthenticated = localStorage.getItem("token");
  
  // Auto-set a demo token if not authenticated (bypass auth for demo)
  if (!isAuthenticated) {
    localStorage.setItem("token", "demo-token-vcc");
    isAuthenticated = "demo-token-vcc";
  }
  
  // Redirect all routes except /vcc to /vcc
  // This ensures only VCC page is accessible
  if (location.pathname !== "/vcc") {
    return <Navigate to="/vcc" replace />;
  }
  
  return props.children;
};

export default ProtectedRoute;
